<ng-container *transloco="let t">
  <section
    class="verified-features"
    [class.mobile]="(biggerThan$ | async)?.xs"
    [class.widescreen]="(biggerThan$ | async)?.mobileL">
    <section>
      <span class="fixed-space-16" aria-hidden="true"></span>
      <ul class="list" [class.mobile]="(lessThan$ | async)?.sm">
        <li class="item popsy-card">
          <popsy-icon-spec-battery class="icon"></popsy-icon-spec-battery>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small">{{ t('label_verified_feature_battery') }}</span>
        </li>

        <li class="item popsy-card">
          <popsy-icon-spec-camera class="icon"></popsy-icon-spec-camera>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small">{{ t('label_verified_feature_camera') }}</span>
        </li>

        <li class="item popsy-card">
          <popsy-icon-spec-wifi class="icon"></popsy-icon-spec-wifi>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small">{{ t('label_verified_feature_wifi') }}</span>
        </li>

        <li class="item popsy-card">
          <popsy-icon-spec-bluetooth class="icon"></popsy-icon-spec-bluetooth>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small">Bluetooth</span>
        </li>

        <li class="item popsy-card">
          <popsy-icon-spec-sound class="icon"></popsy-icon-spec-sound>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small">{{ t('label_verified_feature_speakers') }}</span>
        </li>

        <li class="item popsy-card">
          <popsy-icon-spec-microphone class="icon"></popsy-icon-spec-microphone>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small">{{ t('label_verified_feature_microphone') }}</span>
        </li>

        <li class="item popsy-card">
          <popsy-icon-spec-oxidation class="icon"></popsy-icon-spec-oxidation>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small">{{ t('label_verified_feature_oxidation') }}</span>
        </li>

        <li class="item popsy-card">
          <popsy-icon-spec-usb class="icon"></popsy-icon-spec-usb>
          <span class="fixed-space-8" aria-hidden="true"></span>
          <span class="small">{{ t('label_verified_feature_plug') }}</span>
        </li>
      </ul>
    </section>
  </section>
  <span class="fixed-space-16" aria-hidden="true"></span>
</ng-container>
